import React from "react";
import { USER_FILTER_KEYS } from "../../../../util";
import { Box, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import TipBox from "../../TipBox";
import FilterListIcon from "@material-ui/icons/FilterList";
import HelpItemsList from "../HelpDialog/HelpItemsList";
import SectionTitle from "../HelpDialog/SectionTitle";

const AVAILABLE_DESCRIPTION_FILTERS = [
  { key: USER_FILTER_KEYS.COUNTRIES, label: "app.report.filter.country" },
  { key: USER_FILTER_KEYS.STATES, label: "app.report.filter.state" },
  { key: USER_FILTER_KEYS.CITIES, label: "app.report.filter.city" },
  { key: USER_FILTER_KEYS.ROLES, label: "app.report.filter.role" },
  { key: USER_FILTER_KEYS.CUSTOMER_SITUATIONS, label: "app.report.filter.customerSituation" },
  { key: USER_FILTER_KEYS.AGENT_SITUATIONS, label: "app.report.filter.agentSituation" },
  { key: USER_FILTER_KEYS.AGE_RANGES, label: "app.report.filter.ageRange" },
  { key: USER_FILTER_KEYS.EMAIL_CONFIRMATION, label: "app.report.filter.emailConfirmation" },
  { key: USER_FILTER_KEYS.HAS_BENEFICIARY, label: "app.report.filter.hasBeneficiary" },
  { key: USER_FILTER_KEYS.SELECTED_MONTH_YEAR, label: "app.report.filter.selectedMonthYear" },
  { key: USER_FILTER_KEYS.USERS, label: "app.report.filter.selectedCustomers" },
  { key: USER_FILTER_KEYS.AGENTS, label: "app.report.filter.selectedAgents" },
  { key: USER_FILTER_KEYS.GROUP, label: "app.report.filter.group" },
];

const UsersFiltersDescription = ({ userFilters, classes }) => {
  const activeFilters = AVAILABLE_DESCRIPTION_FILTERS.filter((f) => userFilters?.hasOwnProperty(f.key)).map((f) => f.label);

  if (!activeFilters.length) return null;

  return (
    <Box className={classes.section}>
      <SectionTitle icon={FilterListIcon}>
        <FormattedMessage id="app.report.users.section.filters" />
      </SectionTitle>

      <Typography
        variant="body1"
        paragraph
      >
        <FormattedMessage id="app.report.users.filters.intro" />
      </Typography>

      <HelpItemsList messages={activeFilters} />

      <TipBox>
        <FormattedMessage id="app.report.users.filters.tip" />
      </TipBox>
    </Box>
  );
};

export default UsersFiltersDescription;
